import CustomCheckBox from "@/components/CustomCheckBox/CustomCheckBox.vue"
import UrlBlock from "@/components/UrlBlock/UrlBlock.vue"
import CustomDropdownBorder from "@/components/CustomDropdownBorder/CustomDropdownBorder.vue";
import DropdownBorderV2 from "@/components/CustomDropdownBorder/V2/DropdownV2.vue";
import Skippable from "@/components/Skippable/Skippable.vue";
import RequiredOne from "@/components/RequiredOne/RequiredOne.vue";
import Hint from "@/components/Hint/Hint.vue";
import SocialInformationTooltip from "@/components/SocialInformationTooltip/SocialInformationTooltip.vue";
import check from "../../store/helpers/helper.js";
import {mapGetters} from "vuex";

export default {
    props: {
        elem: {
            type: Object,
            default: () => {
                return {}
            }
        },
        isUpdate: {
            type: Boolean,
            default: false
        },
        length: {
            type: Number,
            default: () => {
                return 0
            }
        },
        last: {
            type: Number,
            default: () => {
                return 0
            }
        },
        lastActive: {
            type: Number,
            default: () => {
                return 0
            }
        },
        blocking: {
            type: Number
        }
    },
    name: "AccordionSocialRow",
    components: {
        CustomCheckBox,
        UrlBlock,
        RequiredOne,
        CustomDropdownBorder,
        Skippable, Hint, SocialInformationTooltip,
        DropdownBorderV2
    },
    data() {
        return {
            item: this.$props.elem,
            arrayOrAnd: [
                {name: 'Or'},
                {name: 'And'},
            ],
            show: false,
            avatar: this.$props.elem.icon ? require(`../../assets/${(this.$props.elem.icon)}-monochrome.svg`) : require(`../../assets/avatar.svg`),
            type: '',
            btn_name_max_length: 50,
        }
    },

    created() {
        if ((this.item.check.inputs.length > 0 && this.item.icon !== 'messenger') || (this.item.check.fillable === false && this.item.status)) {
            this.show = true
        }
        this.type = {name: this.item.check.type}

        this.overwriteIcon()
    },
    methods: {
        selectedAction(item, input) {
            if (!!input.action) {
                return item.actions.filter(v => v.name === input.action)[0]
            } else {
                if (item.actions) {
                    return item.actions[0]
                } else {
                    return null
                }
            }
        },
        overwriteIcon() {
            if (this.$props.elem.icon) {
                let src = this.$props.elem.icon
                if (this.$props.elem.icon === 'messenger') {
                    if (this.$props.elem.name.toLowerCase() === 'telegram') {
                        src = this.$props.elem.name.toLowerCase()
                    }
                }
                this.avatar = require(`../../assets/${(src)}-monochrome.svg`)
            } else {
                this.avatar = require(`../../assets/avatar.svg`)
            }
        },
        addInp(action) {
            let maxIndex = 0;
            // let action = ''
            // if (this.item.name ==='Facebook') {
            //     action = 'Join'
            // }
            // if (this.item.name ==='Instagram' || this.item.name ==='Twitter') {
            //     action = 'Follow'
            // }
            // if (this.item.name ==='YouTube') {
            //     action = 'Subscribe'
            // }
            if (this.item.name ==='Telegram') {
                this.item.check.inputs = []
                this.item.check.inputs.push({ "id": 2, "account": "tlg"})
            }
            if (this.item.name ==='SMS') {
                this.item.check.inputs = []
                this.item.check.inputs.push({"id": 1, "account": "sms"})
            }

            if (this.item.check.inputs.length > 1) {
                maxIndex = this.item.check.inputs.reduce((a, b) => {
                    return (a.id > b.id) ? parseInt(a.id) : parseInt(b.id);
                })
            }
            if (this.item.check.inputs.length === 1) {
                maxIndex = parseInt(this.item.check.inputs[0].id);
            }

            let length = this.item.check.inputs.push({id: /*this.item.check.inputs.length*/maxIndex+1, account: '', button: '', action: action})
            return length - 1;
        },
        removeInp(item) {
            if (this.item.check.fillable) {
                // let index = this.item.check.inputs.lastIndexOf(item)
                let index = this.item.check.inputs.findIndex(input => input.id === item.id)
                this.item.check.inputs.splice(index, 1);
            }
        },
        accordionSocial: function (event) {
            let key = false;
            let obj = event.currentTarget.closest('.accordion-item-social')
            obj.classList.toggle('accordion-item-social-active');
            obj.nextSibling.classList.toggle('and-show');
            this.show = !this.show;
            this.item.status = this.show
            //alert(this.item.sub_id)

            if (this.item.check.fillable) {
                this.item.check.inputs = []
            }

            if (this.item.status) {
                key = this.addInp()
            } else {
                this.item.check.inputs = []
                this.$emit('update_data',this.item.sub_id)
            }
            if (key !== false) {
                if (this.item.actions) {
                    this.item.check.inputs[key].action = (this.item.actions.length) ? this.item.actions[0].name : 'Join';
                }
            }
            this.$emit('updateSortOnAdd', this.item);
        },
        updateType(payload) {
            this.item.check.type = payload.name
        },
        getLink(payload) {
            let index = this.item.check.inputs.findIndex(input => input.id === payload.id)
            this.item.check.inputs[index].account = payload.data
        },
        getButton(payload) {
            let index = this.item.check.inputs.findIndex(input => input.id === payload.id)
            this.item.check.inputs[index].button = payload.data
        },
        test(payload, id) {
            let index = this.item.check.inputs.findIndex(input => input.id === id)
            this.item.check.inputs[index].action = payload.name
        },
        checkLink(link, account) {
            let result = check.checkLink(link, account);
            return result;
        },
    },
    computed: {
        ...mapGetters(['userInfo'])
    }
}
